export default __webpack_public_path__ + "static/media/ns.69d9a96f.png";